// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
// import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown"; // Store Custom Code
// import React, { FC, useEffect, useState } from "react"; // Store Custom Code
import { connect } from "react-redux";

/* Store Custom Code - Start */
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import Tooltip from "@insite/mobius/Tooltip";
import DynamicDropdown, {
    DynamicDropdownPresentationProps,
    OptionObject,
} from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import useHasPageLoadedWithMultipleCustomer from "@store/Framework/Common/Hooks/useHasPageLoadedWithMultipleCustomer";
import useIsModalOverlay from "@store/Framework/Common/Hooks/useIsModalOverlay";
import debounce from "lodash/debounce";
import React, { FC, useCallback, useEffect, useState } from "react";
import constants from "@store/constants";
/* Store Custom Code - End */

interface OwnProps {
    extendedStyles?: ChangeCustomerShipToSelectorStyles;
    setParameter: (parameter: GetShipTosApiParameter) => void;
    parameter: GetShipTosApiParameter;
    searchText?: string; // Store Custom Code
    setSearchText: (searchText: string | undefined) => void; // Store Custom Code - (undefined type)
    enableWarehousePickup: boolean;
    fulfillmentMethod: string;
    shipTo?: ShipToModel;
    billToId?: string;
    allowSelectBillTo?: boolean;
    onSelect: (shipTo: ShipToModel) => void;
    onCreateNewAddressClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    isLoading?: boolean;
    // Store Custom Code
    overridedLabel?: React.ReactNode;
    shipTosInstructions?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, props: OwnProps) => ({
    shipTosDataView: getShipTosDataView(state, props.parameter),
    // Store Custom Code
    currentShipToState: getCurrentShipToState(state),
});

export interface ChangeCustomerShipToSelectorStyles {
    shipToSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const changeCustomerShipToSelectorStyles: ChangeCustomerShipToSelectorStyles = {};

const ChangeCustomerShipToSelector: FC<Props> = ({
    extendedStyles,
    shipTo,
    billToId,
    shipTosDataView,
    onSelect,
    parameter,
    setParameter,
    searchText,
    setSearchText,
    enableWarehousePickup,
    fulfillmentMethod,
    isLoading,
    // Store Custom Code
    overridedLabel,
    shipTosInstructions,
    currentShipToState,
}) => {
    const [styles] = useState(() => mergeToNew(changeCustomerShipToSelectorStyles, extendedStyles));
    const [options, setOptions] = useState<OptionObject[]>([]);
    let dropdownLabel = overridedLabel !== undefined ? overridedLabel : translate("Select Ship To"); // Store Custom Code
    let dropdownPlaceholder = translate("Search or Select Ship To");

    if (enableWarehousePickup && fulfillmentMethod === FulfillmentMethod.PickUp) {
        dropdownLabel = translate("Recipient Address");
        dropdownPlaceholder = translate("Search or Select Recipient Address");
    }

    /* Store Custom Code - Start */
    const hasMultipleCustomers = useHasPageLoadedWithMultipleCustomer(shipTosDataView.value);
    const { useOverlay, scrollElement } = useIsModalOverlay();

    const debouncedSearchShipto = useCallback(
        debounce((query: string | undefined) => {
            setParameter({
                ...parameter,
                filter: query,
            });
        }, constants.searchDebounceDelay),
        [setParameter, parameter],
    );
    /* Store Custom Code - End */

    useEffect(() => {
        setSearchText("");
        setParameter({ ...parameter, billToId, filter: undefined });
    }, [billToId]);

    useEffect(() => {
        debouncedSearchShipto(searchText); // Store Custom Code
    }, [searchText]);

    useEffect(() => {
        if (shipTosDataView.value) {
            const options: OptionObject[] = shipTosDataView.value.map(billTo => ({
                optionText: billTo.label,
                optionValue: billTo.id,
            }));
            setOptions(options);
            if (!shipTo && shipTosDataView.value.length === 1 && !hasMultipleCustomers /* Store Custom Code */) {
                onSelect(shipTosDataView.value[0]);
            }
        }
    }, [shipTosDataView]);

    const selectCustomerHandler = (shipToId?: string) => {
        if (shipTosDataView.value && shipToId) {
            const shipTo = shipTosDataView.value.filter(shipTo => shipTo.id === shipToId)[0];
            if (shipTo) {
                onSelect(shipTo as ShipToModel);
            }
        }
    };

    const searchTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(event.currentTarget.value);
    };

    const onDropdownOpenHandler = (event: React.MouseEvent | React.KeyboardEvent | Event | undefined) => {
        setSearchText("");
    };

    /* Store Custom Code - Start */
    const oneShipToId =
        shipTosDataView.value && shipTosDataView.value.length === 1 && !hasMultipleCustomers
            ? shipTosDataView.value[0].id
            : undefined;
    const selectedItemId = oneShipToId || shipTo?.id;

    const onCloseHandler = () => {
        setSearchText("");
    };

    useEffect(() => {
        const currentShipTo = currentShipToState && currentShipToState.value;
        if (currentShipTo) {
            onSelect(currentShipTo as ShipToModel);
        }
    }, []);
    /* Store Custom Code - End */

    return (
        <DynamicDropdown
            {...styles.shipToSelectorDynamicDropdown}
            /* Store Custom Code - Start */
            label={
                <>
                    {dropdownLabel}
                    {shipTosInstructions && <Tooltip text={shipTosInstructions} />}
                </>
            }
            /* Store Custom Code - End */
            onSelectionChange={selectCustomerHandler}
            onInputChange={searchTextChanged}
            selected={selectedItemId} // Store Custom Code
            placeholder={dropdownPlaceholder}
            isLoading={isLoading}
            options={options}
            // Store Removed - search
            data-test-selector="changeCustomerShipToSelector"
            filterOption={() => true}
            // Store Removed - onOpen
            uid="ChangeCustomerShipToSelector" // Starter Custom Code
            // Store Custom Code
            disabled={Boolean(oneShipToId)}
            onClose={onCloseHandler}
            useOverlay={useOverlay}
            scrollElement={scrollElement}
        />
    );
};

export default connect(mapStateToProps)(ChangeCustomerShipToSelector);
